import moment from 'moment-timezone';
import Parser from 'html-react-parser';
import {
    getLocale,
    convert,
    parseDate
} from './helpers';
import Self from './self';
import config from "../../../config";

const Formatter = {
    int(number, params) {
        const self = Self.getNumber('int', params);

        return self.format(number);
    },

    percent(number) {
        const self = Self.getNumber('percent');

        return self.format(number);
    },

    percentage(number) {
        const self = Self.getNumber('percentage');

        return self.format(number / 100);
    },

    currency(number, currency = 'USD', isHtml = true) {
        const self = Self.getCurrency(currency);

        if (currency === 'XBT') {
            number = number * 1000;
        }

        if (currency === 'XBT') {
            if (isHtml) {
                return Parser(self.format(number).replace('XBT', `m${config.XBT}`));
            }

            return self.format(number).replace('XBT', 'm฿');
        } else {
            return self.format(number);
        }
    },

    currencyBalance(number, currency = 'USD', isHtml = true) {
        const self = Self.getCurrencyBalance(currency);

        if (currency === 'XBT') {
            number = number * 1000;
        }

        if (currency === 'XBT') {
            if (isHtml) {
                return Parser(self.format(number).replace('XBT', `m${config.XBT}`));
            }

            return self.format(number).replace('XBT', 'm฿');
        } else {
            return self.format(number);
        }
    },

    weekDay(number) {
        return new Date(1970, 1 - 1, 4 + number).toLocaleString(getLocale(), {weekday: 'long'});
    },

    date(date, timeZone) {
        const self = Self.getDate('date', timeZone);
        date = parseDate(date, timeZone);
        return self.format(date);
    },

    dateTime(date, timeZone) {
        const self = Self.getDate('dateTime', timeZone);
        date = parseDate(date, timeZone);

        return self.format(date);
    },

    fullDateTime(date, timeZone) {
        const self = Self.getDate('fullDateTime', timeZone);
        date = parseDate(date, timeZone);

        return self.format(date);
    },

    dateWeek(date, timeZone) {
        const self = Self.getDate('date', timeZone);
        date = parseDate(date, timeZone);
        let dateFrom = self.format(date);
        let dateTo = self.format(date.setDate(date.getDate() + 6));

        return `${dateFrom} - ${dateTo}`;
    },

    dateMonth(date, timeZone) {
        const self = Self.getDate('dateMonth', timeZone);
        date = parseDate(date, timeZone);

        return self.format(date);
    },

    dateYear(date, timeZone) {
        const self = Self.getDate('dateYear', timeZone);
        date = parseDate(date, timeZone);

        return self.format(date);
    },

    fromDate(startDate, endDate, timeZone) {
        let delta = endDate - startDate;
        let str = '';
        const duration = moment.duration(convert(delta));
        const locale = moment.localeData(getLocale());
        const format = 'y M d h m s'.match(/y|M|d|h|m|s/ig);

        format.map((key, i) => {
            let value = duration.get(key);

            if (value > 0) {
                str += locale.relativeTime(value, true, `${key}${key}`);

                if (format.length !== i + 1) {
                    str += ' ';
                }
            }
        });
        return str;
    },

    duration(seconds, format = 'm:s') {
        const duration = moment.duration(seconds, 'seconds');
        return format.split(':').map(item => duration.get(item)).join(':');
    }
};

export default Formatter;